import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import TopNavBar from './TopNavBar';
import Sidebar from './Sidebar';
import MobileDrawer from './MobileDrawer';

export function Layout() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div className="app-shell" data-testid="app-shell">
      {/* Sidebar — visible on desktop (lg+), hidden on mobile */}
      <Sidebar />

      {/* Mobile Drawer — slide-in overlay, mobile only */}
      <MobileDrawer isOpen={drawerOpen} onClose={() => setDrawerOpen(false)} />

      {/* Main Content Area */}
      <div className="app-shell-main">
        <TopNavBar onMenuToggle={() => setDrawerOpen(prev => !prev)} />
        <div className="mobile-content" data-testid="content-container">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Layout;
